import { Modal } from 'react-bootstrap';

export interface DialogProps {
  open: boolean;
  close: () => void;
  message: string;
  title: string;
  showButtons: boolean;
  iconClass?: string;
  okText?: string;
  cancelText?: string;
  onConfirm?: Function;
  onCancel?: Function;
  keepOpen?: boolean;
}
const ConfirmationDialog = ({
  open,
  close,
  message,
  title,
  showButtons,
  iconClass,
  okText,
  cancelText,
  onConfirm,
  onCancel,
  keepOpen = true,
}: DialogProps) => {
  const okBtnClick = () => {
    if (onConfirm) {
      onConfirm();
      close();
    } else {
      close();
    }
  };
  const cancelBtnClick = () => {
    if (onCancel) {
      onCancel();
      close();
    } else {
      close();
    }
  };

  return (
    <Modal show={open} onHide={close} backdrop={keepOpen ? 'static' : undefined}>
      <Modal.Header closeButton={!keepOpen}>
        <Modal.Title className='fs-20 lh-24 fw-500'>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {iconClass && <span className={`text-center d-grid fs-80 bi ${iconClass}`}></span>}
        <p className={iconClass ? 'mt-5' : 'mt-2'}>{message}</p>
      </Modal.Body>
      {showButtons && (
        <Modal.Footer className='row justify-content-between'>
          <div className='row gap-3 gap-md-5'>
            <button className='btn btn-primary col-md-5' onClick={okBtnClick}>
              {okText || 'Ok'}
            </button>

            <button className='btn btn-outline-secondary col-md-5' onClick={cancelBtnClick}>
              {cancelText || 'Cancel'}
            </button>
          </div>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export { ConfirmationDialog };
